import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        CocktailDB is a cocktail search and recipe resource, with over 500
        amazing recipes. We are adding more ingredient everyday and we plan to
        make it one of the biggest community of Cocktail enthusiasts. The Goal
        of CocktailDB is to allow Cocktail enthusiasts to explore and try out
        new drinks and have a good time. CocktailDB is founded by cocktail and
        wine enthusiast and software developer Mansi Agrawal.
        <br></br>
        <br></br>Mansi is a Northeastern Graduate student, who enjoys writing
        code and building new things while trying out amazing recipes for
        cocktails. Check her LinkedIn profile and shoot an email if you would
        like to get in touch.
      </p>
    </section>
  )
}

export default About
